import React, { ReactNode } from 'react';
import { makeStyles, Theme } from '@material-ui/core';

const useTextCompStyle = makeStyles<Theme>((theme) => ({
  root0: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    color: 'black',
  },
  root1: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#8a8a8a',
  },
  root2: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#B0B3BF',
  },
  root3: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#202020',
  },
  root4: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#8A8A8A',
  },
  root5: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: 'white',
  },
  root6: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#B0B3BF',
  },
}));

interface ITextComp {
  mode: number;
  text: ReactNode;
  style?: object;
}

// TODO_R: [FRS]
// TODO_R: move into uikit
// TODO_R: better to create <Text> component with variant prop to pass 'caption', 'subtitle' and etc values
const TextComp = ({ mode = 0, text, style = {} }: ITextComp) => {
  const classes = useTextCompStyle();

  return (
    <div className={classes[`root${mode}`]} style={style}>
      {text}
    </div>
  );
};

export default TextComp;
